import type { SVGProps } from 'react';

export type FlagENProps = SVGProps<SVGSVGElement> & {
  size?: number;
};

const NAVY = '#1B3380';
const RED = '#C8362C';
const CREAM = '#F4ECDC';

/** Union Jack — simplified flat construction; no perspective on the saltires. */
export const FlagEN = ({ size = 60, ...rest }: FlagENProps) => (
  <svg
    width={size}
    height={size * (40 / 60)}
    viewBox="0 0 60 40"
    role="img"
    aria-label="English"
    {...rest}
  >
    <title>English</title>
    <rect x="1" y="1" width="58" height="38" fill={NAVY} />
    {/* Diagonals (St Andrew + St Patrick) — drawn as wide cream bands then narrower red overlay. */}
    <g>
      <line x1="1" y1="1" x2="59" y2="39" stroke={CREAM} strokeWidth="7" />
      <line x1="59" y1="1" x2="1" y2="39" stroke={CREAM} strokeWidth="7" />
      <line x1="1" y1="1" x2="59" y2="39" stroke={RED} strokeWidth="2.5" />
      <line x1="59" y1="1" x2="1" y2="39" stroke={RED} strokeWidth="2.5" />
    </g>
    {/* St George's cross — cream backing then red bar. */}
    <rect x="26" y="1" width="8" height="38" fill={CREAM} />
    <rect x="1" y="16" width="58" height="8" fill={CREAM} />
    <rect x="28" y="1" width="4" height="38" fill={RED} />
    <rect x="1" y="18" width="58" height="4" fill={RED} />
    <rect
      x="1"
      y="1"
      width="58"
      height="38"
      fill="none"
      stroke="var(--color-ink)"
      strokeWidth="1.5"
    />
  </svg>
);
